import "./__styles__/App.css";
import Manifest from "./Manifest";
import { useEffect, useState } from "react";
import Logo from "../components/Logo";
import Plugins from "./Plugins";
import {
  AppContainer,
  H2,
  IPAPage,
  LogoSection,
  MenifestSection,
  MenuSection,
  PluginsSection,
} from "./__styles__";
import useManifests from "../__hooks__/useManifests";
import { PLATFORM } from "../config.js";
import { SETTINGS } from "../config.js";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";
import getManifests from "../__hooks__/useManifests";

const RELATIVE_PATH = "/ipaplugins";

function ReleaseManifest({ releasePath }) {
  const [selected, setSelected] = useState(0);
  const [plugins, setPlugins] = useState([]);
  const [manifests, setManifests] = useState([]);

  useEffect(() => {
    (async () => {
      const { manifests, plugins } = await getManifests(releasePath);
      setManifests(manifests);
      setPlugins(plugins);
    })();
  }, [releasePath]);

  const selectedManifest = manifests[selected] || null;

  return (
    <AppContainer>
      <IPAPage>
        <MenuSection>
          <LogoSection>
            <Logo
              url={
                SETTINGS[PLATFORM].REACT_APP_BASE_URL +
                SETTINGS[PLATFORM].REACT_APP_LOGO_URL
              }
            />
          </LogoSection>
          <PluginsSection>
            <H2>IPA Plugin Download</H2>
            {plugins && (
              <Plugins
                systems={plugins}
                onClick={(system, idx) => setSelected(idx)}
                selectedIdx={selected}
              />
            )}
          </PluginsSection>
        </MenuSection>
        <MenifestSection key={selected}>
          {selectedManifest && (
            <Manifest
              system={selectedManifest.system}
              versions={selectedManifest.versions}
            />
          )}
        </MenifestSection>
      </IPAPage>
    </AppContainer>
  );
}

function App() {
  const { releases, isLoading } = useManifests();

  if (isLoading) {
    return <></>;
  }

  return (
    <Router>
      <Routes>
        {/* Default Route */}
        <Route path={RELATIVE_PATH} element={<ReleaseManifest />} />
        {releases &&
          releases.map(({ path }) => (
            <Route
              path={`${RELATIVE_PATH}/${path}`}
              element={<ReleaseManifest releasePath={path} />}
            />
          ))}
        ;
        {/* Fallback Route: Redirect any unknown routes to the default route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
